import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';

import classNames from 'classnames';
import i18n from '../../i18n';
import Home from '../../models/Home';
import InputOptionCollection from '../form/InputOptionCollection';
import { Icon } from '@homeexchange/design';

const HomeTypeCollection = (props) => {
    const { register, errors, formState, handleSubmit } = useForm();

    const isMandatoryFieldsFilled = () =>
        formState.dirtyFields.has('type') && formState.dirtyFields.has('detail[size]');

    const onSubmit = (data) => {
        const { detail } = data;
        if (detail.residence_type) {
            detail.residence_type = Home.RESIDENCE_PRIMARY;
        } else {
            detail.residence_type = Home.RESIDENCE_SECONDARY;
        }
        // set in code because this information will disapear for all user
        detail.location_type = 3;
        props.submitForm(data);
    };

    const renderErrors = (errorsEntity, message) =>
        errorsEntity && (
            <div className="form-errors">
                <span role="alert">
                    <Icon name="ExclamationCircleOutline" color="error" />
                    {message}
                </span>
            </div>
        );

    useEffect(() => {
        props.hasError(!props.data ? !isMandatoryFieldsFilled() : false);
    });

    return (
        <form id="form-step-2" onSubmit={handleSubmit(onSubmit)}>
            <div className="home-type-container">
                <div className="form-group">
                    <label className="form-label">{i18n.t('home:home_type')}</label>
                    <div className="row">
                        <div className="col-xs-5 col-sm-4">
                            <InputOptionCollection
                                name="type"
                                type="radio"
                                label={i18n.t('home:type-home')}
                                ref={register({ required: true })}
                                checked={props.data ? props.data.type == Home.TYPE_HOME : false}
                                id="type-home"
                                value={Home.TYPE_HOME}
                                icon="House"
                            />
                        </div>
                        <div className="col-xs-5 col-sm-4">
                            <InputOptionCollection
                                name="type"
                                type="radio"
                                label={i18n.t('home:type-flat')}
                                ref={register({ required: true })}
                                checked={props.data ? props.data.type == Home.TYPE_APARTMENT : false}
                                id="type-apartment"
                                value={Home.TYPE_APARTMENT}
                                icon="Building"
                            />
                        </div>
                    </div>
                </div>
                <div className="main-house-container">
                    <p>{i18n.t('home:is_main_house')}</p>
                    <label className="toggle">
                        <input
                            name="detail[residence_type]"
                            ref={register}
                            defaultChecked={props.data ? props.data.detail.residence_type == 3 : ''}
                            type="checkbox"
                        />
                        <span className={classNames({ handle: true, withText: true })}>
                            <div>
                                <span className="off-text">{i18n.t('common:no')}</span>
                                <span className="on-text">{i18n.t('common:yes')}</span>
                            </div>
                        </span>
                    </label>
                </div>
            </div>
            <div className="surface-area-container">
                <label className="form-label" htmlFor="size">
                    {i18n.t('home:size')}
                </label>
                <div className="input-surface-container">
                    <input
                        name="detail[size]"
                        className={classNames('input-surface', {
                            'form-errors': errors.detail && errors.detail.size
                        })}
                        defaultValue={props.data ? props.data.detail.size : ''}
                        ref={register({ required: true })}
                        type="number"
                        pattern="[0-9]*"
                        min="1"
                    />
                    <select
                        name="detail[size_unit]"
                        id="metric"
                        defaultValue={props.data ? props.data.detail.size_unit : ''}
                        className="form-control"
                        ref={register({ required: true })}
                    >
                        <option value={Home.METRIC_M2}>m&sup2;</option>
                        <option value={Home.METRIC_SQFT}>ft&sup2;</option>
                    </select>
                </div>
                {!_.isEmpty(errors.detail) &&
                    renderErrors(errors.detail.size, i18n.t('home:error_size_collection'))}
            </div>
        </form>
    );
};

HomeTypeCollection.propTypes = {
    submitForm: PropTypes.func,
    data: PropTypes.object,
    hasError: PropTypes.func
};

export default HomeTypeCollection;
